/**
 * 弱密码检测
 * Created by mengliu4 on 2018/3/6.
 * @author mengliu4
 *
 * 检测密码强度 -1不进行检测  1：弱   2：中   3：强
 * 密码长度为6-16
 * 若密码只是数字、字母和特殊字符中的一种，则密码强度为弱；
 * 若密码是数字、字母和特殊字符三种都有则密码强度为强；
 * 其他状态情况下密码强度为中。
 *
 *
 * 使用示例：
 * var password1="123456";
 * var password2="student1";
 * var password3="student_2";
 * var array = new Array("student1");
 *
 * strongPwd(passport1,array);返回1,标识密码强度为弱
 * strongPwd(passport2,array);返回1,从弱密码库中进行判断
 * strongPwd(passport3,array);返回2,标识密码强度为强
 *
 */

/**
 * 检测密码强度
 * @param password     被检测的密码
 * @param array        支持自定义的弱密码字典检测，弱密码字典为Array类型.没有自定义弱密码库array参数可传null.
 * @returns {number}   密码强度等级   1：弱   2：中  3：强  -1:位数不对，不做检测   -2:含有非法字符
 *
 */
function strongPwd(password,array) {
    if(pwdRule.openStrengthCheck != '1') {
        return 3;
    }
    // 非passportPwdTableRule才需要校验长度，表规则的不能识别出长度
    if (pwdRule.appName != 'passportPwdTableRule'&& password.length< pwdRule.minLength || password.length> pwdRule.maxLength){
        return -1;
    }
    var rule = decodeURIComponent(pwdRule.pwdRule);
    if(!new RegExp(rule).test(password)){
        return -2;
    }
    // 如果是表规则来的，直接返回是强密码
    if (pwdRule.appName === 'passportPwdTableRule') {
        return 3;
    }

    //判断弱密码字典是否为Array类型
    if(Object.prototype.toString.call(array) === '[object Array]'){
        for(var i=0;i<array.length;i++){
            if(password===array[i]){
                return 1;
            }
        }
    }
    var low = decodeURIComponent(pwdRule.lowStrengthRule);
    var middle = decodeURIComponent(pwdRule.middleStrengthRule);
    var high = decodeURIComponent(pwdRule.highStrengthRule);
    if(new RegExp(low).test(password)){
        return 1;
    }else if(new RegExp(middle).test(password)){
        return 2;
    }else if(new RegExp(high).test(password)){
        return 3;
    }else {
        return -2;
    }
}
